
<div class="modal-header">
  <h4 class="modal-title pull-left">Ingresa tu correo</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="myForm" novalidate>
    <input type="email" class="form-control border-input" [(ngModel)]="email" placeholder="usuario@dominio.com" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
           formControlName="email">
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-custom" (click)="onCancel()" >Cancelar</button>
  <button class="btn btn-custom" (click)="sendemail(email)" [disabled]="myForm.invalid">Aceptar</button>
</div>
